import React from "react";
import { Container } from "react-bootstrap";
import aiIotAlarm from "../../../../Asset/aiiot-development-alarms.svg";
import aiIotError from "../../../../Asset/ai-iot-development-error-tracking.svg";
import ailog from "../../../../Asset/ai-iot-log-management.svg";
import aieasy from "../../../../Asset/ai-iot-easy-deployment.svg";

const Third = () => {
  const aiIotCards = [
    {
      id: 1,
      img: aiIotAlarm,
      title: "Alarms",
      description:
        "Immediate Interactive Alerts. These Alert detections are performed in real-time. Our monitoring system helps users to notify when things likely to go wrong and take programmatic action respectively.",
    },
    {
      id: 2,
      img: aiIotError,
      title: "Error Tracking",
      description:
        "Our software is driven by a passion for creating full-stack visibility and enables users to resolve errors faster. We provide end-to-end solutions; track errors, and enable quick and easy troubleshooting. We equip users and developers with the ability to improve the quality and efficiency of IoT-based ecosystems.",
    },
    {
      id: 3,
      img: ailog,
      title: "Log Management",
      description:
        "We apply advanced analytics to discover irregularities for faster investigation and troubleshooting. Our software provides users to harmonize detailed logs across devices, applications, and infrastructure. It is fully automated and frees up wasted time spent manually monitoring and resolving logs.",
    },
    {
      id: 4,
      img: aieasy,
      title: "Easy Deployment",
      description:
        "Smooth data integration across various SaaS and cloud environments for enhanced interconnectivity. Our software integrates data from various sources across multiple domains into one unified platform. We help organizations to manage and develop their integrations on-premises or remotely and build solutions in response to their specific needs.",
    },
  ];
  return (
    <>
      <section
        className="feature-list-block"
        style={{ backgroundColor: "var(--white-color)" }}
      >
        <Container>
          <div className="top-text-third-webDevelopment">
            <h2>
              HOW WE <span>DO ?</span>
            </h2>
          </div>
          <div className="row card-items">
            {aiIotCards?.map(({ id, img, title, description }) => (
              <div key={id} className="col-md-6 flex-column mb-50">
                <div className="card-item no-hover">
                  <div className="card-img">
                    <img alt={title} src={img} />
                  </div>
                  <div className="card-content">
                    <h3>{title}</h3>
                    <p className="sort-info">{description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </>
  );
};

export default Third;
